export const GP_DEFAULT = 'DEFAULT'
export const GP_WORKING_FAKE = 'WORKING_FAKE'
export const GP_VERIFYING_IDENTITY = 'GP_VERIFYING_IDENTITY'
export const GP_VERIFY_IDENTITY_SUCCESS = 'GP_VERIFY_IDENTITY_SUCCESS'
export const GP_VERIFYING_BANK_ACCOUNT = 'VERIFYING_BANK_ACCOUNT'
export const GP_VERIFY_BANK_ACCOUNT_SUCCESS = 'VERIFY_BANK_ACCOUNT_SUCCESS'
